import React, { useState, useEffect } from 'react';
import { Route, Routes, Navigate, createBrowserRouter, createRoutesFromElements, RouterProvider } from 'react-router-dom';

import {
	TranslatedString
} from '@bosch/bt-ui';

import withErrorHandler from '../components/ErrorHandler';
import LoggedInPages from './LoggedInPages';
import PageNotFoundPage from '../pages/PageNotFoundPage';
import LoginPage from '../pages/LoginPage';
import LoginPageLayout from '../layouts/LoginPageLayout';
import DefaultLayout from '../layouts/DefaultLayout';
import HomePage from '../pages/HomePage';
import SimManagement from '../pages/sim-management/SimManagementPage';
import SimDetailPage from '../pages/sim-detail-page/SimDetailPage';
import CompanyPage from '../pages/company-page/CompanyPage';
import UpdateCompanyPage from '../pages/company-page/update-company/UpdateCompanyPage';
import { useToken } from '../components/useToken';
import AddCompanyPage from '../pages/company-page/add-company/AddCompanyPage';
import SimActivationDetail from '../pages/sim-activation-detail-page/SimActivationDetailPage';
import PanelManagementPage from '../pages/panel-management-page/PanelManagementPage';
import PanelEnvironmentPage from '../pages/panel-environment-page/PanelEnvironmentPage';
import CSRManagement from '../pages/csr-management/CSRManagementPage';
import UserManagement from '../pages/user-management/UserManagementPage';
import UserAction from '../pages/user-action-detail-page/UserActionDetailPage';
import WCMetrics from '../pages/wc-metrics-page/WebConnectMetricsPage';
import { prepareLogData } from '../components/Util';

function getReturnUrl(queryString) {
	const queryParams = new URLSearchParams(queryString);

	const returnUrl = queryParams.get('return-url');

	if (returnUrl === '' || returnUrl === '/login' || returnUrl === '/logout')
		return null;

	return returnUrl;
}

const Page = () => {
	console.log('<Page>', window.location.href);
	const { token, deleteToken, setToken, isLoggedIn } = useToken();
	const [isDirty, setIsDirty] = useState(false)

	const returnUrl = getReturnUrl(location.search);
	console.log('returnUrl:', returnUrl, token.authenticated);

	const baseRouter = new URL(SUPPORTCONSOLE_API_URL).pathname;

	// When keycloak logout success, redirect to /logout path to delete cookie after
	useEffect(() => {
		if (window.location.pathname === '/logout' || window.location.pathname === baseRouter + '/logout') {
			console.log('OOXX:', returnUrl, token.authenticated);
			if (isLoggedIn()) {
				deleteToken();
			}
			const data = prepareLogData(token,'HomePage', 'UserLogOut');

			fetch(SUPPORTCONSOLE_API_URL + '/api/activity/v1/activitylog', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + token.token
				},
				body: JSON.stringify(data)
			})
			//Add activity log
		}
	}, [deleteToken, isLoggedIn, returnUrl, token.authenticated, baseRouter,token]);

	const router = createBrowserRouter(
		createRoutesFromElements(
			<Route
				path="/*"
				element={
					<Routes>
						<Route 
							path="/login"
							element={
								isLoggedIn() ?
									<Navigate to={returnUrl || '/'} replace />
									:
									<LoginPageLayout>
										<LoginPage token={token} setToken={setToken} />
									</LoginPageLayout>
							}
						/>
						<Route 
							path="/logout"
							element={
								isLoggedIn() ? <Navigate to={'/logout'} replace /> : <Navigate to={'/'} replace />
							}
						/>
						<Route 
							path="/" exact
							element={
								<DefaultLayout
									token={token}
									activeMenuId='home-page'
									pageTitle={<TranslatedString stringId="title-home-page" />}
									isDirty={isDirty} setIsDirty={setIsDirty}
								>
									<HomePage token={token} parentUrl="/" />
								</DefaultLayout>
							}
						/>
						<Route
							path="/*" exact
							element={
								<LoggedInPages token={token} deleteToken={deleteToken} isLoggedIn={isLoggedIn}>
									<Routes>
										<Route 
											path="/simmanagement" exact
											element={
												<DefaultLayout
													token={token}
													activeMenuId='sim-management'
													pageTitle={<TranslatedString stringId="title-sim-management" />}
													isDirty={isDirty} setIsDirty={setIsDirty}
												>
													<SimManagement token={token} parentUrl="/simmanagement" />
												</DefaultLayout>
											}
										/>
										{/* Winston */}
										<Route 
											path="/sim-detail" exact
											element={
												<DefaultLayout
													token={token}
													activeMenuId='sim-detail-page'
													pageTitle={<TranslatedString stringId="title-sim-information" />}
													isDirty={isDirty} setIsDirty={setIsDirty}
												>
													<SimDetailPage token={token} parentUrl="/sim-detail" />
												</DefaultLayout>
											}
										/>
										<Route 
											path="/company" exact
											element={
												<DefaultLayout
													token={token}
													activeMenuId='company-page'
													pageTitle={<TranslatedString stringId="title-company-page" />}
													isDirty={isDirty} setIsDirty={setIsDirty}
												>
													<CompanyPage token={token} parentUrl="/company-page" />
												</DefaultLayout>
											}
										/>
										<Route 
											path="/company/update/:companyId?/:companyName?/:customerId?" exact
											element={
												<DefaultLayout
													token={token}
													activeMenuId='company-page'
													pageTitle={<TranslatedString stringId="title-company-page" />}
													isDirty={isDirty} setIsDirty={setIsDirty}
												>
													<UpdateCompanyPage token={token} setIsDirty={setIsDirty} parentUrl="/company-page" />
												</DefaultLayout>
											}
										/>
										<Route 
											path="/company/add/:sapCompanyId?/:sapSalesRegion?/:companyName?/:deviceRegion?" exact
											element={
												<DefaultLayout
													token={token}
													activeMenuId='company-page'
													pageTitle={<TranslatedString stringId="title-company-page" />}
													isDirty={isDirty} setIsDirty={setIsDirty}
												>
													<AddCompanyPage token={token} setIsDirty={setIsDirty} parentUrl="/company-page" />
												</DefaultLayout>	
											}
										/>
										<Route 
											path="/simactivationdetail" exact
											element={
												<DefaultLayout
													token={token}
													activeMenuId='sim-activation-detail-page'
													pageTitle={<TranslatedString stringId="title-sim-activation-detail" />}
													isDirty={isDirty} setIsDirty={setIsDirty}
												>
													<SimActivationDetail token={token} parentUrl="/sim-activation-detail-page" />
												</DefaultLayout>
											}
										/>
										{/* MICS-1659 SC- Allow to reach SIMACtivity Detail page by transaction ID on URL */}
										{/* This route will release for SP team to read activity log, so DO NOT change this URL */}
										<Route 
											path="/simactivitylog" exact
											element={
												<SimActivationDetail token={token} parentUrl="/sim-activation-detail-page" />
											}
										/>
										<Route 
											path="/panel-management" exact
											element={
													<DefaultLayout
													token={token}
													activeMenuId='panel-management-page'
													pageTitle={<TranslatedString stringId="title-panel-management-page" />}
													isDirty={isDirty} setIsDirty={setIsDirty}
												>
													<PanelManagementPage token={token} isLoggedIn={isLoggedIn} parentUrl="/panel-management" />
												</DefaultLayout>
											}
										/>
										<Route 
											path="/panel-environment" exact
											element={
													<DefaultLayout
													token={token}
													activeMenuId='panel-environment-page'
													pageTitle={<TranslatedString stringId="title-panel-environment-page" />}
													isDirty={isDirty} setIsDirty={setIsDirty}
												>
													<PanelEnvironmentPage token={token} isLoggedIn={isLoggedIn} parentUrl="/panel-environment" />
												</DefaultLayout>
											}
										/>
										<Route 
											path="/csr-management" exact
											element={
												<DefaultLayout
													token={token}
													activeMenuId='csr-management-page'
													pageTitle={<TranslatedString stringId="title-csr-management" />}
													isDirty={isDirty} setIsDirty={setIsDirty}
												>
													<CSRManagement token={token} isLoggedIn={isLoggedIn} parentUrl="/csr-management" />
												</DefaultLayout>
											}
										/>
										<Route 
											path="/user-management" exact
											element={
												<DefaultLayout
													token={token}
													activeMenuId='user-management-page'
													pageTitle={<TranslatedString stringId="title-user-management" />}
													isDirty={isDirty} setIsDirty={setIsDirty}
												>
													<UserManagement token={token} isLoggedIn={isLoggedIn} parentUrl="/user-management" />
												</DefaultLayout>
											}
										/>
										<Route 
											path="/user-action-detail" exact
											element={
												<DefaultLayout
													token={token}
													activeMenuId='user-action-detail-page'
													pageTitle={<TranslatedString stringId="title-user-action-detail" />}
													isDirty={isDirty} setIsDirty={setIsDirty}
												>
													<UserAction token={token} isLoggedIn={isLoggedIn} parentUrl="/user-action-detail" />
												</DefaultLayout>
											}
										/>										
										<Route 
											path="/wc-metrics" exact
											element={
												<DefaultLayout
													token={token}
													activeMenuId='wc-metrics-page'
													pageTitle={<TranslatedString stringId="title-wc-metrics" />}
													isDirty={isDirty} setIsDirty={setIsDirty}
												>
													<WCMetrics token={token} isLoggedIn={isLoggedIn} parentUrl="/wc-metrics" />
												</DefaultLayout>
											}
										/>
										<Route 
											path="/wc-metrics-redirect" exact
											element={
												<Navigate to="/wc-metrics" replace />
											}
										/>
									</Routes>
								</LoggedInPages>
							}
						/>
						<Route 
							element={
								<PageNotFoundPage />
							}
						/>
					</Routes>
				}
			/>
		)
	  );

	return (
		<RouterProvider router={router} />
	);
};

export default withErrorHandler(React.memo(Page));
